module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1034-6e8cd20498377c905dca3ad645d92f82.png";